import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

declare var $: any; // Pour utiliser jQuery si fullcalendar est chargé via script

@Component({
  selector: 'p-schedule',
  template: `<div class="calendar-container">
  <div #calendar></div>
</div>`,
  styles: [`
.h3, h3 {
  font-size: 24px;
}
.calendar-container {
  width: 100%;
  overflow: hidden;
}


::ng-deep .fc-basicDay-view {

  .fc-day-header,
.fc-bg .fc-day,
.fc-content-col,
.fc-resource-cell {
  width: 256px !important;
  min-width: 256px !important;
  max-width: 256px !important;
}
}



  `]
})
export class PScheduleComponent implements AfterViewInit, OnDestroy {
  @ViewChild('calendar', { static: true }) calendarRef!: ElementRef;

  // Inputs (API similaire à PrimeNG Schedule)
  @Input() events: any[] = [];
  @Input() header: any;
  @Input() style: any;
  @Input() styleClass: string = '';
  @Input() rtl: boolean = false;
  @Input() weekends: boolean = true;
  @Input() hiddenDays: number[] = [];
  @Input() fixedWeekCount: boolean = true;
  @Input() weekNumbers: boolean = false;
  @Input() businessHours: any;
  @Input() height: any;
  @Input() contentHeight: any;
  @Input() aspectRatio: number = 1.35;
  @Input() eventLimit: boolean = false;
  @Input() defaultDate: string = '';
  @Input() editable: boolean = false;
  @Input() droppable: boolean = false;
  @Input() eventStartEditable: boolean = true;
  @Input() eventDurationEditable: boolean = true;
  @Input() defaultView: string = 'month';
  @Input() allDaySlot: boolean = true;
  @Input() slotDuration: string = '00:30:00';
  @Input() slotLabelInterval: any;
  @Input() scrollTime: string = '06:00:00';
  @Input() minTime: string = '00:00:00';
  @Input() maxTime: string = '24:00:00';
  @Input() locale: string = 'fr';
  @Input() options: any = {};
  @Input() eventRender: any;

  // Outputs
  @Output() onDayClick = new EventEmitter<any>();
  @Output() onDrop = new EventEmitter<any>();
  @Output() onEventClick = new EventEmitter<any>();
  @Output() onEventMouseover = new EventEmitter<any>();
  @Output() onEventMouseout = new EventEmitter<any>();
  @Output() onEventDragStart = new EventEmitter<any>();
  @Output() onEventDragStop = new EventEmitter<any>();
  @Output() onEventDrop = new EventEmitter<any>();
  @Output() onEventResize = new EventEmitter<any>();
  @Output() onViewRender = new EventEmitter<any>();
  @Output() onEventReceive = new EventEmitter<any>();

  private calendar: any;

  get calendarElement(): HTMLElement {
    return this.calendarRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this.initializeCalendar();
  }

  initializeCalendar(): void {
    const config = {
      header: this.header,
      isRTL: this.rtl,
      weekends: this.weekends,
      hiddenDays: this.hiddenDays,
      fixedWeekCount: this.fixedWeekCount,
      weekNumbers: this.weekNumbers,
      businessHours: this.businessHours,
      height: this.height,
      contentHeight: this.contentHeight,
      aspectRatio: this.aspectRatio,
      eventLimit: this.eventLimit,
      defaultDate: this.defaultDate || new Date(),
      editable: this.editable,
      droppable: this.droppable,
      eventStartEditable: this.eventStartEditable,
      eventDurationEditable: this.eventDurationEditable,
      defaultView: this.defaultView,
      allDaySlot: this.allDaySlot,
      slotDuration: this.slotDuration,
      slotLabelInterval: this.slotLabelInterval,
      scrollTime: this.scrollTime,
      minTime: this.minTime,
      maxTime: this.maxTime,
      locale: this.locale,
      events: this.events,
      eventRender: this.eventRender,

      dayClick: (date, jsEvent, view) => this.onDayClick.emit({ date, jsEvent, view }),
      drop: (event) => this.onDrop.emit(event),
      eventClick: (calEvent, jsEvent, view) => this.onEventClick.emit({ calEvent, jsEvent, view }),
      eventMouseover: (calEvent, jsEvent) => this.onEventMouseover.emit({ calEvent, jsEvent }),
      eventMouseout: (calEvent, jsEvent) => this.onEventMouseout.emit({ calEvent, jsEvent }),
      eventDragStart: (event, jsEvent, ui, view) => {
        console.log(event, jsEvent, ui, view)
        this.onEventDragStart.emit({ event, jsEvent, ui, view });
        // this.startAutoScroll(jsEvent); // <-- Lance le suivi du drag
      },
      eventDragStop: (event, jsEvent, ui, view) => {
        this.onEventDragStop.emit({ event, jsEvent, ui, view });
        // this.stopAutoScroll(); // <-- Arrête le suivi
      },
      eventDrop: (event, delta, revertFunc, jsEvent, ui, view) =>
        this.onEventDrop.emit({ event, delta, revertFunc, jsEvent, ui, view }),
      eventResize: (event, delta, revertFunc, jsEvent, ui, view) =>
        this.onEventResize.emit({ event, delta, revertFunc, jsEvent, ui, view }),
      viewRender: (view, element) => {
        this.onViewRender.emit({ view, element });

        // setTimeout(() => {
        //   this.syncTables();

        //   // Synchronisation du scroll
        //   const $scroller = element.find('.fc-scroller');
        //   $scroller.off('scroll.fcSync').on('scroll.fcSync', function () {
        //     element.find('.fc-head').scrollLeft($(this).scrollLeft());
        //   });
        // }, 50);

      },
      eventReceive: (event, delta, revertFunc, jsEvent, ui, view) =>
        this.onEventReceive.emit({ event, delta, revertFunc, jsEvent, ui, view }),

      ...this.options
    };

    // Initialisation via jQuery (si fullcalendar est dispo via scripts globaux)
    this.calendar = $(this.calendarRef.nativeElement);
    this.calendar.fullCalendar(config);
  }

  ngOnDestroy(): void {
    if (this.calendar) {
      this.calendar.fullCalendar('destroy');
    }
  }

  private syncTables(): void {
    const $fcHeadTable = $(this.calendarRef.nativeElement).find('.fc-basicDay-view .fc-head table');
    const $fcBodyTable = $(this.calendarRef.nativeElement).find('.fc-basicDay-view .fc-scroller table');
    const $fcscroller = $(this.calendarRef.nativeElement).find('.fc-basicDay-view .fc-scroller');
    const $fcheadcontainer = $(this.calendarRef.nativeElement).find('.fc-basicDay-view .fc-head-container');

    if ($fcHeadTable && $fcHeadTable[0]) {
      // 1. Récupération de la largeur exacte du header
      const headWidth = $fcHeadTable[0].scrollWidth;

      $fcscroller.css('width', `${headWidth}px`);
      $fcheadcontainer.css('width', `${headWidth}px`);
      // 2. Application au tableau du body
      $fcBodyTable.css({
        'width': `${headWidth}px`,
        'min-width': '100%' // Garde la responsivité
      });

      // 3. Synchronisation instantanée
      $fcHeadTable.css('width', `${headWidth}px`);
    }

  }

  // Variables pour le contrôle du scroll
  private scrollInterval: any;
  private readonly SCROLL_ZONE = 50; // Zone en px déclenchant le scroll
  private readonly SCROLL_SPEED = 20; // Vitesse de scroll

  private startAutoScroll(jsEvent: MouseEvent): void {
    const $scroller = $(this.calendarRef.nativeElement).find('.fc-scroller');

    if ($scroller && $scroller[0]) {
      const scroller = $scroller[0];
      this.scrollInterval = setInterval(() => {
        const rect = scroller.getBoundingClientRect();
        const mouseX = jsEvent.clientX;

        // Scroll vers la droite si la souris est proche du bord droit
        if (mouseX > rect.right - this.SCROLL_ZONE) {
          scroller.scrollLeft += this.SCROLL_SPEED;
        }
        // Scroll vers la gauche si la souris est proche du bord gauche
        else if (mouseX < rect.left + this.SCROLL_ZONE) {
          scroller.scrollLeft -= this.SCROLL_SPEED;
        }
      }, 50); // Rafraîchissement toutes les 50ms
    }
  }

  private stopAutoScroll(): void {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
  }
}
